// eslint-disable-next-line no-shadow
export enum BaseButtonVariants {
	TEXT = 'text',
	OUTLINED = 'outlined',
	CONTAINED = 'contained',
}
